<template>
  <!--
    Wise Owl

    Shows a small colored info alert
      icon: owl (default) or an info icon if "chat" prop is set to true
      color: light blueish (default), or orange with "warning" prop set to true
      margin: none or surrended by a margin 5 in x direction if "inset" prop is set to true
  -->
  <v-alert
    :color="getColor"
    dense
    :icon="getIcon"
    text
    type="info"
    class="text-left"
    :class="this.inset ? 'mx-5' : ''"
  >
    <slot></slot>
  </v-alert>
</template>

<script>

export default {
  name: 'AdInfoOwl',
  props: {
    chat: {
      type: Boolean,
      required: false,
      default: false
    },
    warning: {
      type: Boolean,
      required: false
    },
    error: {
      type: Boolean,
      required: false
    },
    subtle: {
      type: Boolean,
      required: false
    },
    inset: {
      type: Boolean,
      required: false,
      default: false
    },
    darker: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  components: {},
  computed: {
    getIcon () {
      return this.chat ? 'mdi-chat-alert-outline' : 'mdi-owl'
    },
    getColor () {
      if (this.warning) return 'warning'
      if (this.error) return 'error'
      if (this.subtle) return 'grey'
      return 'info'
    }
  },
  data () {
    return {
      icon: null
    }
  },
  methods: {
  }
}
</script>
